import { render, staticRenderFns } from "./gamifyOperatorTab.vue?vue&type=template&id=49b34c8e&lang=pug"
import script from "./gamifyOperatorTab.vue?vue&type=script&lang=js"
export * from "./gamifyOperatorTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports